export default "__VITE_ASSET__BzhbA5fa__"